import React, { useState } from 'react';
import { ImCancelCircle } from 'react-icons/im';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { BeatLoader } from "react-spinners";
import './ConfirmModal.css';

interface ConfirmModalProps {
  onAccept: () => void;
  onCancel: () => void;
  color?: string;
  title?: string;
  message?: string;
}

function ConfirmModal({ 
  onAccept, 
  onCancel, 
  color = "#4F5052", 
  title = "Confirm Action",
  message = "Are you sure you want to delete this item?"
}: ConfirmModalProps) {
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    await onAccept();
    setLoading(false);
  };

  return (
    <div className="confirm-modal-wrapper">
      <div className="confirm-modal-container">
        <div className="confirm-modal-header" style={{ backgroundColor: color }}>
          <h2 className="confirm-modal-title">{title}</h2>
          <button 
            className="close-button" 
            onClick={onCancel}
            aria-label="Close"
          >
            <ImCancelCircle size={22} />
          </button>
        </div>

        <div className="confirm-modal-content">
          <div className="confirm-modal-icon">
            <ExclamationCircleOutlined />
          </div>
          
          <p className="confirm-modal-message">{message}</p>

          {loading && (
            <div className="loader-container">
              <BeatLoader color={color} />
            </div>
          )}

          <div className="confirm-modal-actions">
            <button 
              className="cancel-button"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              className="confirm-button"
              onClick={handleAccept}
              disabled={loading}
              style={{ backgroundColor: color }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
      <div className="confirm-modal-overlay" onClick={onCancel} />
    </div>
  );
}

export default ConfirmModal;